export default __webpack_public_path__ + "static/media/kitchen5-afterC-1024w.3072c2b5.avif";